import { LocalizationUtils, TrackingUtils } from "../../utils";
import React, { useCallback, useMemo } from "react";

import ChecklistComponent from "../common/Checklist";
import { LocalizationMessages } from "../../localization/messages";
import PropTypes from "prop-types";
import { UISelectors } from "../../redux/selectors";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useThemeModeHandler } from "./hooks";

export const ThemeModeItems = ({ trackingInfo, onClick }) => {
  const themeModeSettings = useSelector(UISelectors.themeModeSettings);
  const selectedThemeMode = useSelector(UISelectors.themeMode);
  const { parseThemeMode } = useThemeModeHandler();
  const { formatMessage } = useIntl();

  const sendChecklistClickAnalytics = useCallback(
    item => {
      const checklistItemTrackingInfo = Object.assign({}, trackingInfo, {
        dataLabel: `${item.name}`
      });

      TrackingUtils.sendAnalytics(checklistItemTrackingInfo);
    },
    [trackingInfo]
  );

  const themeModeChecklistTitle = useMemo(() => {
    const themeModeCheclistTitle = formatMessage(
      LocalizationMessages.themeModeChecklistTitle
    );

    return themeModeCheclistTitle;
  }, [formatMessage]);

  const themeModeChecklistItems = useMemo(() => {
    const getThemeName = code => {
      let themeName = null;

      if (code) {
        const localizationMessageId = LocalizationUtils.getByCode(
          "themeModeCode",
          code
        );

        const localizationMessage = LocalizationMessages[localizationMessageId];

        if (localizationMessage) themeName = formatMessage(localizationMessage);
      }

      return themeName;
    };

    const themeModeChecklistItems = themeModeSettings?.map(themeMode => {
      const themeName = getThemeName(themeMode.code);

      return {
        code: themeMode.code,
        name: !themeName ? themeMode.name : themeName,
        isChecked: themeMode.code === selectedThemeMode.code,
        dataTestId: `select-${themeMode.name.toLowerCase()}`
      };
    });

    return themeModeChecklistItems;
  }, [selectedThemeMode, themeModeSettings, formatMessage]);

  const onChecklistClick = useCallback(
    item => {
      sendChecklistClickAnalytics(item);

      const selectedThemeMode = parseThemeMode(item.code);
      onClick(selectedThemeMode);
    },
    [sendChecklistClickAnalytics, parseThemeMode, onClick]
  );

  return (
    <ChecklistComponent
      title={themeModeChecklistTitle}
      items={themeModeChecklistItems}
      onClick={onChecklistClick}
      trackingInfo={trackingInfo}
    ></ChecklistComponent>
  );
};

ThemeModeItems.propTypes = {
  trackingInfo: PropTypes.object,
  onClick: PropTypes.func
};
